'use client';

import { useState } from 'react';

/**
 * ArticleFAQs component renders a list of FAQs with an accordion style.
 * Answers are provided as an array of react elements because they can contain
 * server components.
 */
export default function ArticleFAQs({ settings, answers }) {
  const [activeIndex, setActiveIndex] = useState(null);

  function toggleFaqAccordion(index) {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  }

  return (
    settings?.faq_qa?.length > 0 && (
      <section id="article-faq" className="my-15">
        <h2 className="h4 jump-offset mb-1">
          {settings?.article_faq_title || 'Frequently Asked Questions'}
        </h2>
        {settings.faq_qa.map((faq, index) => {
          if (!answers?.[index]) {
            return null;
          }

          return (
            <div
              className="group border-dawn-grey-60 w-full border-b pr-4 text-left focus:outline-none"
              key={`faq-${index}`}
            >
              <button
                className="group relative flex w-full cursor-pointer items-center justify-between py-4 transition"
                onClick={() => toggleFaqAccordion(index)}
              >
                <div className="flex w-full justify-between text-left">
                  <span className="grow pr-4">
                    <h3 className="sh10 text-cozy-cognac group-hover:text-cozy-cognac-130 transition">
                      {faq.faq_question}
                    </h3>
                  </span>
                  <span
                    className={`bg-cozy-cognac group-hover:bg-cozy-cognac-130 toggle-open flex-none text-right ${activeIndex === index ? 'toggle-close' : ''}`}
                  />
                </div>
              </button>
              <div
                className={`body-r mb-1 ${activeIndex === index ? 'max-h-screen' : 'max-h-0'} overflow-hidden ${activeIndex === index ? 'duration-600 ease-in' : 'duration-300 ease-out'}`}
              >
                {answers[index]}
              </div>
            </div>
          );
        })}
      </section>
    )
  );
}
